<div class="accordion">
  <div class="accordion-header" (click)="toggleAccordion()">
    <h3>{{ header }}</h3>
    <span [ngClass]="{'arrow-down': isCollapsed, 'arrow-up': !isCollapsed}"></span>
  </div>
  <div class="accordion-content" [ngClass]="{'collapsed': isCollapsed}">
    <ng-content></ng-content>
  </div>
</div>